import translations from './translations.json';

export const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
    }
  }
}

export const dateTimeFormats = {
  'en-US': {
    time: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    shortWithTime: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }
  }
};

export default {
  ...translations
}
